export const version = "abi/5.0.9";
//# sourceMappingURL=_version.js.map